import React from "react";

const MainPageWrapper = (props) => {
  return <div className="main-wrapper">{props.children}</div>;
};

export default MainPageWrapper;
